module.exports = __webpack_public_path__ + "static/advice6-17aa3ec2f8ef34f7434fa33163052fe7.png";